<template>
  <div class="register pr" :style="`background-image: url(${$store.state.user.backgroundImage});`">
    <el-form ref="registerForm" :model="registerForm" :rules="registerRules" class="register-form">
      <h3 class="title fweight500 fsize24">注册</h3>
      <el-form-item prop="userName">
        <el-input v-model="registerForm.userName" type="text" auto-complete="new-password" placeholder="请输入真实姓名"
          @keyup.enter.native="handleRegister">
        </el-input>
      </el-form-item>
      <el-form-item prop="idCard">
        <el-input v-model="registerForm.idCard" type="text" auto-complete="new-password" placeholder="请输入身份证号"
          @keyup.enter.native="handleRegister" maxlength="18">
        </el-input>
      </el-form-item>
      <el-form-item prop="phonenumber">
        <el-input v-model="registerForm.phonenumber" type="text" auto-complete="new-password" placeholder="请输入手机号码" maxlength="11">
        </el-input>
      </el-form-item>
      <el-form-item prop="smsCode">
        <el-input v-model="registerForm.smsCode" type="text" auto-complete="new-password" placeholder="请输入短信验证码" style="width: 188px"
          @keyup.enter.native="handleRegister">
        </el-input>
        <el-button v-if="!countDown" plain class="getCode" @click="handleCapctchaCheck">发送验证码</el-button>
        <span v-else style="margin-left: 14px; color: #565656">{{ countDown }} 秒后重新发送</span>
      </el-form-item>
      <el-form-item prop="password">
        <el-input v-model="registerForm.password" type="password" auto-complete="new-password" placeholder="请输入登陆密码（12-16位数字和字母组合）"
          @keyup.enter.native="handleRegister">
        </el-input>
      </el-form-item>
      <!-- <el-form-item prop="confirmPassword">
        <el-input
          v-model="registerForm.confirmPassword"
          type="password"
          auto-complete="new-password"
          placeholder="确认密码"
          @keyup.enter.native="handleRegister"
        >
        </el-input>
      </el-form-item> -->
      <el-form-item prop="email">
        <el-input v-model="registerForm.email" auto-complete="off" placeholder="请输入邮箱" style="width: 100%"
          @keyup.enter.native="handleRegister">
        </el-input>
      </el-form-item>
      <el-form-item style="width: 100%">
        <el-button class="marginBom30 registerBtn" :loading="loading" size="medium" type="primary" style="width: 100%"
          @click.native.prevent="handleRegister">
          <span v-if="!loading">注 册</span>
          <span v-else>注 册 中...</span>
        </el-button>
        <div class="flex-xCenter">
          已有账号，<router-link class="link-type fcolor_darkBlue" :to="'/login'">立刻登录</router-link>
        </div>
      </el-form-item>
    </el-form>

    <Verify @success="capctchaCheckSuccess" :mode="'pop'" :captchaType="'blockPuzzle'"
      :imgSize="{ width: '330px', height: '155px' }" ref="verify"></Verify>

    <!--  底部  -->
    <!-- <div class="brand-footer">
      <span class="fcolor_gray2">Copyright © 浙江大学医学院附属邵逸夫医院</span>
    </div> -->
  </div>
</template>

<script>
import { getCaptcha, register, sendSmsCode } from "@/utils/api";
import Verify from "@/components/Verifition/Verify";

export default {
  name: "Register",
  components: { Verify },
  data() {
    const equalToPassword = (rule, value, callback) => {
      if (this.registerForm.password !== value) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    };
    return {
      countDown: 0,
      codeUrl: "",
      registerForm: {
        userName: "",
        idCard: "",
        phonenumber: "",
        code: "",
        uuid: "",
        password: "",
        email: "",
        confirmPassword: "",
      },
      registerRules: {
        userName: [
          { required: true, trigger: "blur", message: "请输入您的姓名" },
          {
            min: 2,
            max: 8,
            message: "用户姓名长度必须介于 2 和 8 之间",
            trigger: "blur",
          },
        ],
        idCard: [
          { required: true, trigger: "blur", message: "请输入您的身份证号" },
          {
            min: 18,
            max: 18,
            message: "身份证号码长度必须为18位",
            trigger: "blur",
          },
        ],
        phonenumber: [
          { required: true, trigger: "blur", message: "请输入您的手机号码" },
          {
            min: 11,
            max: 11,
            message: "手机号码长度必须为11位",
            trigger: "blur",
          },
        ],
        smsCode: [
          { required: true, trigger: "blur", message: "请输入短信验证码" },
          {
            min: 6,
            max: 6,
            message: "请输入正确的验证码",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, trigger: "blur", message: "请输入您的登录密码" },
          {
            min: 12,
            max: 16,
            message: "用户密码12-16位数字和字母组合",
            trigger: "blur",
          },
        ],
        email: [
          { required: true, trigger: "blur", message: "请输入您的邮箱地址" },
          {
            validator: function (rule, value, callback) {
              if (
                /^\w{1,64}@[a-z0-9\-]{1,256}(\.[a-z]{2,6}){1,2}$/i.test(
                  value
                ) == false
              ) {
                callback(new Error("邮箱格式错误"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        // confirmPassword: [
        //   { required: true, trigger: "blur", message: "请再次输入您的密码" },
        //   { required: true, validator: equalToPassword, trigger: "blur" },
        // ],
        code: [{ required: true, trigger: "change", message: "请输入验证码" }],
      },
      loading: false,
      captchaEnabled: true,
    };
  },
  created() {
  },
  methods: {
    // 注册
    handleRegister(e) {
      this.$refs.registerForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          register(this.registerForm).then((res) => {
            const userName = this.registerForm.userName;
            this.$alert(
              "<font color='red'>恭喜你，您的账号 " +
              userName +
              " 注册成功！</font>",
              "系统提示",
              {
                dangerouslyUseHTMLString: true,
                type: "success",
              }
            ).then(() => {
              this.$router.push("/login");
            })
          }).catch(() => {
            this.loading = false;
          });
        }
      });
    },
    // 验证
    handleCapctchaCheck() {
      this.$refs.registerForm.validateField(['phonenumber'], valid => {
        if (!valid) {
          // 验证通过
          this.$refs.verify.show();
        }
      })
    },
    capctchaCheckSuccess(params) {
      sendSmsCode({
        phonenumber: this.registerForm.phonenumber,
        code: params.captchaVerification
      }).then(res => {
        this.countDown = 60
        let that = this

        let interval = setInterval(() => {
          that.countDown = this.countDown - 1
          if (that.countDown <= 0) {
            clearInterval(interval)
          }
        }, 1000);

        this.$message.success(res.msg);
      })
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
::v-deep .el-form-item__error {
  position: static !important;
}

.register {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-size: cover;
}

.title {
  margin: 0px auto 48px auto;
  text-align: center;
  color: rgba(0, 0, 0, 0.9);
}

.flex-xCenter {
  line-height: 19px;
}

.register-form {
  box-sizing: border-box;
  border-radius: 6px;
  background: #ffffff;
  width: 400px;
  position: absolute;
  right: 235px;
  top: 108px;
  padding: 30px 40px;

  .el-input {
    height: 40px;

    input {
      padding-left: 11px;
      height: 40px;
    }
  }

  .getCode {
    width: 126px;
    margin-left: 6px;
    border-radius: 3px;
    background-color: #fff;
    color: #253d88;
  }

  .registerBtn {
    height: 48px;
  }

  .input-icon {
    height: 40px;
    width: 14px;
    margin-left: 2px;
  }

  &>.el-form-item:not(:nth-child(9)) {
    margin-bottom: 8px;
  }

  &>.el-form-item:nth-child(9) {
    margin-bottom: 30px;
  }
}

.register-tip {
  font-size: 13px;
  text-align: center;
  color: #bfbfbf;
}

.register-code {
  width: 33%;
  height: 38px;
  float: right;

  img {
    cursor: pointer;
    vertical-align: middle;
  }
}

.register-code-img {
  height: 38px;
}
</style>
